export const PlanType = {
    LAUNCH: 'LAUNCH',
    GROWTH: 'GROWTH',
    PREMIUM: "PREMIUM",
    ZERO: 'ZERO',
    ONE: 'ONE',
    TWO: 'TWO',
    // Added for 2025
    BASE_2025: 'BASE_2025',
    LAUNCH_2025: 'LAUNCH_2025',
    SEED_2025: 'SEED_2025',
    GROW_2025: 'GROW_2025',
    PRIME_2025: 'PRIME_2025',
    ELITE_2025: 'ELITE_2025',
};
